/**
 * agent-6-1 PR C (decision agent-d37): what a run environment save sends for its workspace directory.
 *
 * Applied AFTER `removeFalsyValues`, which would drop a cleared field and so leave the stored value in
 * place: an agent environment always sends the directory, null when blank (the server's default,
 * `~/foundry-workspaces`). An SSH environment sends nothing, so its stored value is left alone.
 */
export const withWorkspaceBase = <T extends object>(
  profile: T,
  transport: string | null | undefined,
  value: string | null | undefined
): T & { workspaceBase?: string | null } => {
  if ("agent" !== transport) return profile;
  return { ...profile, workspaceBase: value?.trim() || null };
};
